// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

///////
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/zh-CN'
//////////

import global from "./utils/Global"
import $ from 'jquery'
import 'bootstrap'
import axios from 'axios'
// axios.defaults.withCredentials=true;//让ajax携带cookie
import qs from 'qs'

//vue-touch
import VueTouch from 'vue-touch'
Vue.use(VueTouch, { name: 'v-touch' })
VueTouch.config.swipe = {
  threshold: 50  //设置左右滑动的距离
}


/////font/////
import '@/assets/css/fontawesome.css'
import '@/assets/css/iconfont.css'
import '@/assets/css/font.css'
////////

//////vuex store///////
import Vuex from 'vuex'
Vue.use(Vuex);
import '@/assets/css/custom/theme1/index.css';
import store from './store/store.js';

/////
import VueParticles from 'vue-particles'
Vue.use(VueParticles)

// // 引入vue-UUID组件
// import UUID from 'vue-uuid'
// Vue.use(UUID)

//////
import ErrorPlugin from './components/plugin/errorPlugin'
Vue.use(ErrorPlugin)

////
// import CodeEditor from 'bin-code-editor';
// Vue.use(CodeEditor);
// 视频组件
// import VideoPlayer from 'vue-video'
// Vue.use(VideoPlayer)
// import VueCoreVideoPlayer from 'vue-core-video-player'
// Vue.use(VueCoreVideoPlayer)

// Vue.use(VueCoreVideoPlayer, { lang: 'zh-CN'})
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)

Vue.config.productionTip = false

Vue.prototype.customGlobal = global
Vue.prototype.axios = axios
Vue.prototype.qs = qs

/* eslint-disable no-new */
let flag = 0
router.beforeEach((to, from, next) => {

  //console.info("每次进入路由前，进行全局检测from:"+from.path+",to:"+to.path+",userInfo:"+JSON.stringify(global.userInfo));
  global.refreshGlobalDetail(global);

  // //if(to.name!='login'){
  // if(to.path!=='/login'){
  //   // global.lastUrl = to.name;
  global.lastUrl = to.path;
  // }
  //
  if (global.userInfo.authed === 'success') {
    console.info("成功通过检测")
    // next();
    ///////////
    var userMenuForPermission = window.sessionStorage.getItem("userMenuForPermission");
    if (userMenuForPermission && flag === 0) {
      ////////
      let dtRouter = global.refreshDtRouter(userMenuForPermission);
      router.addRoutes(dtRouter);
      // /////
      flag++
      next({ ...to, replace: true })
    } else {

      next();
    }
    //////////////
  } else {

    //console.info("需要登录后才可以访问")
    //if(to.name=='login'){
    if (to.path === '/login' || to.path === '/login_device') {
      //console.info("跳转login中")
      next();
      return;

    } else {
      //console.info("向login跳转")
      //next({name:'login'});
      if (to.query.code === undefined) {
        next({ path: '/login' });
      } else {
        next({ path: '/login', query: { code: to.query.code } });
      }

    }


  }

})

/* 路由异常错误处理，尝试解析一个异步组件时发生错误，重新渲染目标页面 */
router.onError((error) => {
  console.log('---------------------------------------------------------');
  console.log(error);
  // const pattern = /Loading chunk (\d)+ failed/g;
  // const isChunkLoadFailed = error.message.match(pattern);
  // const targetPath = router.history.pending.fullPath;
  // if (isChunkLoadFailed) {
  //   router.replace(targetPath);
  // }
});


Vue.use(ElementUI);
// Vue.use(ElementUI, { size: 'small', zIndex: 3000 ,locale });


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'

})




// WEBPACK FOOTER //
// ./src/main.js